module.exports = __webpack_public_path__ + "static/media/notification-settings.cd8a765d.svg";